import {GoogleMap, Marker, useLoadScript} from '@react-google-maps/api';

import './About.less';

import React, {Component} from 'react';

const MyMapComponent = () => {
    const {isLoaded, loadError} = useLoadScript({
        googleMapsApiKey: 'AIzaSyBhzlST8S63iZiYfRDjSbYTXw8CjlMu_Os',
        libraries: ['places'],
    });

    if (loadError) return <div>Error loading maps</div>;
    if (!isLoaded) return <div>Loading...</div>;

    return (
        <GoogleMap mapContainerStyle={{height: '400px', width: '100%'}} zoom={8} center={{lat: -34.397, lng: 150.644}}>
            <Marker position={{lat: -34.397, lng: 150.644}} />
        </GoogleMap>
    );
};

export default class About extends Component {
    render() {
        return (
            <div>
                <MyMapComponent />
            </div>
        );
    }
}
